import GanhoPesoService from "./ganhoPesoService";
export class GanhoPesoManager {
  /**
   * @returns {Promise<Array<CurvaGanhoPeso>>} A promise that resolves to an array of weight gain curves.
   */
  async listWeightGainCurves(farmId) {
    try {
      const response = await GanhoPesoService.obterCurvasPorFazenda(farmId);
      return response.data;
    } catch (_) {
      throw new Error("Erro ao listar curvas de ganho de peso");
    }
  }

  async obterCurvasGanhoPeso(fazendaSelecionada) {
    const respostaService = await GanhoPesoService.obterCurvasPorFazenda(
      fazendaSelecionada
    );
    let curvas = respostaService.data;
    return curvas;
  }

  async excluirCurva(idCurvaGanhoPeso) {
    await GanhoPesoService.deletarCurva(idCurvaGanhoPeso);
  }

  async salvarCurva(curva) {
    const respostaService = await GanhoPesoService.adicionarCurva(curva);
    return respostaService.data;
  }
  async editarCurva(curva, idCurvaGanhoPeso) {
    await GanhoPesoService.editarCurva(curva, idCurvaGanhoPeso);
  }
}

export default new GanhoPesoManager();
